import { render } from "./TheTrackerDetails.vue?vue&type=template&id=085b3ed1"
import script from "./TheTrackerDetails.vue?vue&type=script&lang=js"
export * from "./TheTrackerDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__